import React from "react";
import { Link } from "react-router-dom";

export function OverlayLink({ to, children, className = "", ...props }) {
  return (
    <Link {...props} className={className + " overlay-link"} to={to}>
      {children}
    </Link>
  );
}

export function FocusContainer({ tag, className = "", children, ...props }) {
  const Wrapper = React.createElement(
    tag,
    {
      ...props,
      className: "focus-container " + className,
    },
    children
  );
  return Wrapper;
}
